import { deleteMethod, post } from "src/api";
import { ProblemItem } from "src/types";

export const createProblemItem: (
  problem: ProblemItem
) => Promise<ProblemItem> = (problem) => post<ProblemItem>("/problem", problem);

export const deleteProblem: (id: number) => Promise<void> = (id) =>
  deleteMethod(`/problem/${id!}`);
